import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { WjCoreModule } from '@grapecity/wijmo.angular2.core';

import { CheckPlanGoodsService } from './api-services/check-plan-goods.service';
import { ClearPlanGoodsChangeManageService } from './api-services/clear-plan-goods-change-manage.service';
import { GetCoopPlanNumService } from './api-services/get-coop-plan-num.service';
import { GetDelivCatalogIDService } from './api-services/get-deliv-catalog-id.service';
import { GetNextGuideService } from './api-services/get-next-guide.service';
import { GetPlanGoodsMaintainService } from './api-services/get-plan-goods-maintain.service';

import { GetPublishVoiceHistoryService } from './api-services/get-publish-voice-history.service';
import { CheckNgWordsService } from '../../kymw02/check-ng-words/api-services/check-ng-words.service';
import { GetSupplierService } from './api-services/get-supplier.service';
import { GetGuideInfoService } from './api-services/get-guide-info.service';
import { GetPreOrderFlagService } from './api-services/get-pre-order-flag.service';
import { GetPreOrderService } from './api-services/get-pre-order.service';
import { GetPlanGoodsECService } from './api-services/get-plan-goods-ec.service';
import { GetImageDataService } from './api-services/get-image-data.service';
import { GetStockInfoService } from './api-services/get-stock-info.service';
import { GetGroupingInfoService } from './api-services/get-grouping-info.service';
import { GetWebLinkInfoService } from './api-services/get-web-link-info.service';
import { GetGroupingListService } from './api-services/get-grouping-list.service';
import { GetGroupingDataService } from './api-services/get-grouping-data.service';
import { GetTagListService } from './api-services/get-tag-list.service';

import { KYMW0900Component } from './kymw0900.component';

import { KYMW0A00Module } from '../../kymw0a/kymw0a00/kymw0a00.module';
import { KYMW0400Module } from '../../kymw04/kymw0400/kymw0400.module';
import { KYMW0600Module } from '../../kymw06/kymw0600/kymw0600.module';
import { KYMW0700Module } from '../../kymw07/kymw0700/kymw0700.module';
import { KYMW0901Module } from '../kymw0901/kymw0901.module';
import { KYMW0905Module } from '../kymw0905/kymw0905.module';
import { KYMW0906Module } from '../kymw0906/kymw0906.module';
import { KYMW0907Module } from '../kymw0907/kymw0907.module'; 
import { KYMW0908Module } from '../kymw0908/kymw0908.module';
import { KYMW0909Module } from '../kymw0909/kymw0909.module';
import { KYMW1600Module } from '../../../kymw/kymw16/kymw1600/kymw1600.module';

import { GetDefaultConsumeTaxInfoService } from './api-services/get-default-consume-tax-info.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GetOrderNumQuotaCodeListService } from './api-services/get-order-num-quota-code-list.service';
import { PlanGoodsLotteryPromotionService } from './api-services/get-plan-goods-lottery-promotion.service';
import { NumberOfUsersService } from './api-services/get-number-of-users.service';
import { PlanGoodsPointExchangePromotionService } from './api-services/get-plan-goods-point-exchange-promotion.service';
import { PlanGoodsNvalPromotionService } from './api-services/get-plan-goods-nval-promotion.service';
import { PlanGoodsCouponPromotionService } from './api-services/get-plan-goods-coupon-promotion.service';

import { ImgaeInfoRenderModule } from './imgae-info-render/image-info-renderer.module';
import { GetNotUseCoopService } from './api-services/get-not-use-coop.service';
import { PlanGoodsLockService } from '../../../commons/kymw00/api-services/plan-goods-lock.service';
import { GetGoodsUseCoopService } from './api-services/get-goods-use-coop.service';
import { GetIconDataService } from './api-services/get-icon-data.service';
import { GetSelectedNvalMediumListService } from './api-services/get-selected-nval-medium-list.service';
import { GetGoodsSupplyPriceService } from './api-services/get-goods-supply-price.service';

/**
 * 商品企画メンテナンス画面 モジュール設定クラス
 *
 * @export KYMW0900Module
 * @class KYMW0900Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    SharedModule,
    WjCoreModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW0A00Module,
    KYMW0400Module,
    KYMW0600Module,
    KYMW0700Module,
    KYMW0901Module,
    KYMW0905Module,
    KYMW0906Module,
    KYMW0907Module,
    KYMW0908Module,
    KYMW0909Module,
    KYMW1600Module,
    FontAwesomeModule,
    WjGridFilterModule,
    ImgaeInfoRenderModule,
  ],
  declarations: [
    KYMW0900Component,
  ],
  providers: [
    PlanGoodsLockService,
    CheckPlanGoodsService,
    ClearPlanGoodsChangeManageService,
    GetCoopPlanNumService,
    GetDelivCatalogIDService,
    GetNextGuideService,
    GetPlanGoodsMaintainService,
    GetPublishVoiceHistoryService,
    GetSupplierService,
    GetDefaultConsumeTaxInfoService,
    CheckNgWordsService,
    GetGuideInfoService,
    GetOrderNumQuotaCodeListService,
    PlanGoodsLotteryPromotionService,
    NumberOfUsersService,
    PlanGoodsPointExchangePromotionService,
    PlanGoodsNvalPromotionService,
    PlanGoodsCouponPromotionService,
    GetPreOrderFlagService,
    GetPreOrderService,
    GetPlanGoodsECService,
    GetImageDataService,
    GetStockInfoService,
    GetGroupingInfoService,
    GetWebLinkInfoService,
    GetGroupingListService,
    GetGroupingDataService,
    GetTagListService,
    GetNotUseCoopService,
    GetGoodsUseCoopService,
    GetIconDataService,
    GetSelectedNvalMediumListService,
    GetGoodsSupplyPriceService,
  ],
})
export class KYMW0900Module {
}
